export default "__VITE_ASSET__C_qJkPy5__"